module.exports = __webpack_public_path__ + "static/img/banco-do-brasil-horizontal.6804efd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logos/banco-do-brasil-horizontal.jpg
// module id = BgDq
// module chunks = 3